<template>
  <div class="simple-line">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.simple-line {
  font-size: 18px;
}
</style>
